import { Box, useMediaQuery } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { Helmet } from "react-helmet";
import HeaderLayout from "../components/layout/HeaderLayout";

type AdminLayoutProps = {
  children: ReactNode;
};

const AdminLayout = (props: AdminLayoutProps) => {
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <Box>
      <Helmet>
        <title>Freeshu | Dashboard</title>
      </Helmet>
      <HeaderLayout />
      <Box p={isLargerThan900 ? "10" : "1"}>{props.children}</Box>
    </Box>
  );
};

export default AdminLayout;
